/**
 * Track a custom conversion event in Umami.
 * Safe to call even if the Umami script hasn't loaded yet.
 *
 * @param {string} event  - Event name  (e.g. 'clic-telephone')
 * @param {object} [props] - Optional key/value payload
 */
export const track = (event, props) => {
  try {
    if (window.umami) window.umami.track(event, props);
  } catch (_) {
    // Never break the UI if analytics fails
  }
};
